module.exports = __webpack_public_path__ + "static/cta-1-moc-1-105efc959845edb1700c0977d73c3fd1.png";